import { render, staticRenderFns } from "./ListsMenu.vue?vue&type=template&id=2032a23d"
import script from "./ListsMenu.vue?vue&type=script&lang=js"
export * from "./ListsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports